import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router";
import { Auth } from "../../context/AuthContext";
import * as firebase from "firebase";

const Login = () => {
  const { usuario } = useContext(Auth);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  let history = useHistory();

  const [formData, setFormData] = useState(dataForm());

  useEffect(() => {
    const validaUsuario = () => {
      if (usuario) history.push("/admin/producto");
    };
    validaUsuario();
  }, [usuario, history]);

  const { email, password } = formData;
  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validarUsuario = e => {
    e.preventDefault();
    setIsError(false);
    setCargando(false);
    setError("");

    if (!email || !password) {
      setIsError(true);
      setError("Ingresar usuario y contraseña.");
    } else {
      setCargando(true);
      firebase
        .auth()
        .signInWithEmailAndPassword(formData.email, formData.password)
        .then(response => {
          setCargando(false);
          history.push("/admin/administrar");
        })
        .catch(e => {
          setCargando(false);
          setIsError(true);
          const { code } = e;
          if (code === "auth/wrong-password") {
            setError("Usuario ó Contraseña incorrecto.");
          } else {
            setError("Ocurrió un error al iniciar sesión. Intentar mas tarde.");
          }
        });
    }
  };

  function dataForm() {
    return {
      email: "",
      password: ""
    };
  }

  return (
    <>
      <form className="mt-5" onSubmit={validarUsuario}>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-6 col-lg-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Correo</label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                name="email"
                onChange={handleChange}
                value={email}
              />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">Contraseña</label>
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                name="password"
                onChange={handleChange}
                value={password}
              />
            </div>

            <button class="btn btn-primary" type="submit">
              {cargando && (
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}{" "}
              Ingresar
            </button>

            {isError && (
              <div class="alert alert-danger mt-2" role="alert">
                {error}
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default Login;
